/**
 * AvtoFix Client — entry point
 *
 * React 19 createRoot bilan App'ni mount qilish.
 * StrictMode development'da double-render orqali bug'larni topish uchun.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './shared/i18n'; // i18n init (side-effect)
import { applyStyle, getStyle } from './shared/lib/style-theme';
import './styles/global.css';

// Saqlangan dizayn STILINI ERTA qo'llaymiz — stil "flash" bo'lmasin.
applyStyle(getStyle());

// ── Stale-deploy guard (oq ekran oldini olish) ──────────────────────
// Yangi deploy'dan keyin foydalanuvchining ESKI cache'langan bundle'i o'zgargan
// lazy chunk'ni yuklay olmasligi mumkin (modulepreload 404 → oq ekran). Bunda
// sahifani BIR MARTA qayta yuklaymiz → no-cache index.html yangi chunk'larni
// oladi. 10s loop-guard: agar qayta yuklashdan keyin ham xato bo'lsa (haqiqiy
// 404), to'xtaymiz (cheksiz reload bo'lmasin).
const RELOAD_FLAG = 'avfx-chunk-reload';
function recoverFromStaleChunk(): void {
  const last = Number(sessionStorage.getItem(RELOAD_FLAG) ?? '0');
  const now = Date.now();
  if (now - last < 10_000) return; // yaqinda urindik — loop oldini olamiz
  sessionStorage.setItem(RELOAD_FLAG, String(now));
  window.location.reload();
}
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  recoverFromStaleChunk();
});
window.addEventListener('unhandledrejection', (event) => {
  const reason: unknown = event.reason;
  const msg =
    reason instanceof Error ? reason.message : typeof reason === 'string' ? reason : '';
  if (/dynamically imported module|ChunkLoadError|module script failed|Failed to fetch dynamically/i.test(msg)) {
    recoverFromStaleChunk();
  }
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error("Root element ('#root') topilmadi index.html ichida");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
